import { v4 } from 'uuid';
const PROD_URL = 'https://5bc8eantf0.execute-api.eu-central-1.amazonaws.com/production';
let PWA_SHARE_API_URI = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : PROD_URL;

PWA_SHARE_API_URI = PROD_URL;

const deviceId = v4();

export function getDeviceId() {
  return deviceId;
}

export function savePwaShareData<TData = any>(data: TData) {
  const deviceId = getDeviceId();
  const url = `${PWA_SHARE_API_URI}/share/?id=${deviceId}`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}

const shareDataChache = new Map<string, any>();

export async function retrievePwaShareData<TData = any>(deviceId: string) {
  if (shareDataChache.has(deviceId)) {
    return shareDataChache.get(deviceId);
  }
  const url = `${PWA_SHARE_API_URI}/share/?id=${deviceId}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.status.toString().startsWith('2')) {
    return null;
  }

  const result = (await response.json()) as TData;

  shareDataChache.set(deviceId, result);

  return result;
}
